export const PICKUP_LOCATIONS = [
  { value: "현관앞" },
  { value: "우체통" },
  { value: "경비실" },
  { value: "무인택배함", displayText: "무인택배함 (비밀번호가 있는경우 기타 선택)" },
];
export const PICKUP_LOCATION_ETC = "기타";
